/**
 * The Dashboard's greeting title (flowstack#2002): "Good morning, Ada".
 *
 * The part of the day comes from the browser's local clock; the name is the
 * first word of the session's effective `display_name` (the user's Settings
 * override, else the sign-in name). When that name is just the email — a
 * Cognito user with no `name` attribute and no override — there is no first
 * name to greet, and the title stays "Dashboard".
 */

export type PartOfDay = "morning" | "afternoon" | "evening";

/** 05:00–11:59 morning, 12:00–17:59 afternoon, the rest evening. */
export function partOfDay(now: Date): PartOfDay {
  const hour = now.getHours();
  if (hour >= 5 && hour < 12) return "morning";
  if (hour >= 12 && hour < 18) return "afternoon";
  return "evening";
}

interface NamedSession {
  display_name: string;
  email: string;
}

/** The first word of the effective name, or `null` when it is empty or the email. */
export function firstName(session: NamedSession | null | undefined): string | null {
  const name = session?.display_name?.trim();
  if (!name) return null;
  if (name.toLowerCase() === session?.email?.trim().toLowerCase()) return null;
  return name.split(/\s+/)[0] ?? null;
}

export function dashboardTitle(session: NamedSession | null | undefined, now: Date): string {
  const name = firstName(session);
  return name ? `Good ${partOfDay(now)}, ${name}` : "Dashboard";
}
